import { Component, inject, signal, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { TabsModule } from 'primeng/tabs';
import { StatusBar } from '@shared/components/status-bar/status-bar';
import { MenuItem } from 'primeng/api';
import { Menu, MenuModule } from 'primeng/menu';
import { NavBar } from '@shared/components/nav-bar/nav-bar';
import { PermissionService, RECURSOS, RECURSOS_PANEL_ALERTAS } from '@auth/services/permission.service';

@Component({
  selector: 'app-config-page',
  imports: [TabsModule, RouterLink, RouterOutlet, StatusBar, MenuModule, NavBar],
  templateUrl: './config-page.html',
  styleUrl: './config-page.css',
})
export class ConfigPage {
  @ViewChild('menu') menu!: Menu;
  router = inject(Router);
  perm = inject(PermissionService);
  RECURSOS = RECURSOS;
  RECURSOS_PANEL_ALERTAS = RECURSOS_PANEL_ALERTAS;

  selectedMenuItems = signal<MenuItem[]>([]);
  tabs = [
    { route: 'entidades', label: 'Entidades', icon: 'pi pi-home' },
    { route: 'usuarios', label: 'Usuarios', icon: 'pi pi-chart-line' },
    { route: 'medicamentos', label: 'Medicamentos', icon: 'pi pi-list' },
    { route: 'app_config', label: 'Sistema', icon: 'pi pi-inbox' },
  ];

  items: Record<string, MenuItem[]> = {
    app_config: [
      {
        label: 'Configuración',
        items: [
          {
            label: 'Formularios',
            icon: 'pi pi-book',
            command: () => {
              this.router.navigate(['/configuracion/formularios']);
            },
          },
          {
            label: 'Tablas',
            icon: 'pi pi-table',
            command: () => {
              this.router.navigate(['/configuracion/tablas']);
            },
          },
          {
            label: 'Reportes',
            icon: 'pi pi-file-excel',
            command: () => {
              this.router.navigate(['/configuracion/reportes']);
            },
          },
        ],
      },
    ],
  };

  openTabMenu(tabName: string, event: Event) {
    this.selectedMenuItems.set(this.items[tabName]);
    this.menu.toggle(event);
  }
}
